import { notify, state } from './state.ts';

declare global {
  interface Window {
    /** Debug/test handle (same idea as aka-mocap-viewer's window.aka). */
    __aka?: { state: typeof state; drawCount?: number };
  }
}
window.__aka = { state };
import { addFiles } from './clips.ts';
import { initPreview } from './ui/preview.ts';
import { initTransport } from './ui/transport.ts';
import { initSidebar } from './ui/sidebar.ts';

initSidebar();
initTransport();
initPreview();

// Drag-and-drop anywhere on the page adds clips.
let dragDepth = 0;
window.addEventListener('dragenter', (e) => {
  e.preventDefault();
  dragDepth++;
  document.body.classList.add('drag-active');
});
window.addEventListener('dragleave', () => {
  dragDepth = Math.max(0, dragDepth - 1);
  if (!dragDepth) document.body.classList.remove('drag-active');
});
window.addEventListener('dragover', (e) => e.preventDefault());
window.addEventListener('drop', (e) => {
  e.preventDefault();
  dragDepth = 0;
  document.body.classList.remove('drag-active');
  if (e.dataTransfer?.files.length) void addFiles(e.dataTransfer.files);
});
// Internal drags (clip re-ordering) never reach the bubble-phase window drop
// handler (the clip list stops propagation, and dragend fires on a node the
// re-render already detached) — clear the highlight in capture phase instead,
// plus dragend for drags cancelled without a drop.
const clearDragHighlight = (): void => {
  dragDepth = 0;
  document.body.classList.remove('drag-active');
};
window.addEventListener('drop', clearDragHighlight, true);
window.addEventListener('dragend', clearDragHighlight);

notify();

import { loadComparisonParameters } from "./compareLinks.ts";
void loadComparisonParameters();

